module.exports = ".focus--mouse {\n  outline: none !important;\n}\n"